import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const FloatingContainer = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      ref,
      className: twMerge(
        "bg-floating-color fill-floating-color shadow-[0px_1px_16px_2px_rgba(13,16,33,0.08),1px_6px_32px_rgba(5,22,35,0.06)] outline-none rounded-lg z-10",
        className
      ),
      children
    }
  );
});
export {
  FloatingContainer as default
};
//# sourceMappingURL=FloatingContainer.js.map
